import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { catchError, tap, throwError } from 'rxjs';
import { VerifyService } from '../components/verify/service/verify.service';
import { LoginService } from '../components/login/service/login.service';
import * as CryptoJS from 'crypto-js'; 
 
export const authuserInterceptor: HttpInterceptorFn = (req, next):any => {
   const router = inject(Router);
   const notifier = inject(NotifierService);
   const verifyService = inject(VerifyService);
   const loginService = inject(LoginService);
    
   //  let  hexTimestamp =   CryptoJS.AES.encrypt(JSON.stringify(now),service.enCryptKey);
    let  hexTimestamp = verifyService.dateTimeToHex();
    let tokenRequest:any;
  
  let user = localStorage.getItem("loginuser");
  let token = sessionStorage.getItem("token");
  // if(verifyService.verifyToken && user){
  //     tokenRequest = req.clone({
  //     setHeaders:{loginuser:user,token:verifyService.verifyToken,
  //       'content-security-policy':"img-src 'self' data: blob:; frame-ancestors 'self' script-src 'self' 'unsafe-eval'"
  //       //'content-security-policy':"img-src 'self' data: blob:; frame-ancestors 'self'; style-src 'self' https://fonts.googleapis.com; font-src 'self' https://fonts.gstatic.com;",
  //      }
  //    });
  // }else 
  const bodyObj = req.body;
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(bodyObj), loginService.enCryptKey);
  const encryptStr = { data: ciphertext.toString() };
  //admin_matrix1@acinfotech.com
  // const url = req.url;
  //   console.log('Request URL:', url);
  //   if(url.indexOf("check-email-verify") != -1){
  //     req = req.clone({ body: encryptStr });
  //   }
  
  if(user && token){
       user = CryptoJS.AES.encrypt(user,loginService.enCryptKey).toString();
        let loginuser:any = localStorage.getItem("loginuser");
    tokenRequest = req.clone({
       setHeaders:{token:token,'x-meta-token':hexTimestamp,'x-email-token':'e4cfa7e2b3a94a6b3e87f82616e7dbf00aaf34d3ce2b2a68e1cf34ff9438d9d3'
     // setHeaders:{token:token,'x-meta-token':hexTimestamp,'x-email-id':loginuser,'x-email-token':'e4cfa7e2b3a94a6b3e87f82616e7dbf00aaf34d3ce2b2a68e1cf34ff9438d9d3'
       // 'content-security-policy':"img-src 'self' data: blob:; frame-ancestors 'self'; script-src 'self' 'unsafe-eval'"
        //'content-security-policy':"img-src 'self' data: blob:; frame-ancestors 'self'; style-src 'self' https://fonts.googleapis.com; font-src 'self' https://fonts.gstatic.com;",
       }
     });
  }else if(user){
    user = CryptoJS.AES.encrypt(user,loginService.enCryptKey).toString();
    tokenRequest = req.clone({
      setHeaders:{
         'x-meta-token':hexTimestamp,
        // 'content-security-policy':"img-src 'self' data: blob:; frame-ancestors 'self'; script-src 'self' 'unsafe-eval'"
       // 'content-security-policy':"img-src 'self' data: blob:; frame-ancestors 'self'; style-src 'self' https://fonts.googleapis.com; font-src 'self' https://fonts.gstatic.com;",
       }
     });
  }else{
     tokenRequest = req;
  }
   
  return next(tokenRequest).pipe(
    tap((event: any) => {
    // clear previous notifications on successful response
    if (event instanceof HttpResponse) {
      notifier.hideAll();
    }
  }),
  catchError((error: HttpErrorResponse) => {
    let message = 'Something went wrong. Please try again later.';

    const handleAuthError = () => {
      localStorage.clear();
      router.navigateByUrl('login');
    };

    switch (error.status) {
      case 0:
        if (navigator.onLine) {
          message =
            'We are unable to reach the server at this time. Please try again shortly.';
        } else {
          message =
            'No internet connection detected. Kindly check your network connection and try again.';
        }
        break;

      case 400:
        // Validation error
        message =
          error?.error?.message || 'Invalid request. Please check your input.';
        break;

      case 401:
        // Unauthorized
        message = 'Session expired. Please login again.';
        handleAuthError();
        break;

      case 403:
        // Forbidden / token expired
        message = 'Access denied or session expired. Please login again.';
        handleAuthError();
        break;

      case 404:
        message = 'Requested resource not found.';
        break;

      case 500:
        message = 'Server error. Please try again later.';
        break;

      default:
        // fallback to backend message if available
        message = error?.error?.message || message;
        break;
    }

    // Notify user
    notifier.hideAll();
    notifier.notify('error', message);

  // Optional: log error (recommended in production)
    console.error('HTTP Error:', error);

    return throwError(() => error);
  })
);
};
